<app-standard-bottom-sheet [isOpen]="isOpen"
                           (isOpenChange)="onSheetOpenChange($event)"
                           [preventOverlayClose]="false"
                           [isFullScreen]="true"
                           testId="add-new-item-sheet">
  <app-section-header title="Add New Item"
                      align="center"
                      testId="add-new-item-header" />

  <form [formGroup]="form"
        class="add-new-item-form"
        data-testid="add-new-item-form">

    <app-form-field label="BQ Step"
                    inputId="add-item-bq-step"
                    [required]="true"
                    [control]="form.controls.buildQualityStep"
                    [invalid]="isInvalid('buildQualityStep')"
                    [errorMessages]="{ required: 'Please select a BQ step.' }">
      <app-select-field inputId="add-item-bq-step"
                        formControlName="buildQualityStep"
                        [options]="bqStepOptions"
                        optionLabel="label"
                        optionValue="value"
                        [autoFocusFilter]="false"
                        optionDisabled="disabled"
                        placeholder="Select BQ Step"
                        panelStyleClass="add-new-item-bq-step-overlay"
                        [invalid]="isInvalid('buildQualityStep')"
                        (disabledOptionClick)="onLockedBqStepClick($event)"
                        testId="add-new-item-bq-step">
        <ng-template #selectOptionItem
                     let-option
                     let-disabled="disabled">
          <div class="bq-step-option"
               [class.bq-step-option--disabled]="disabled">
            <span class="bq-step-option__lock"
                  [class.bq-step-option__lock--visible]="disabled">
              <i class="pi pi-lock"
                 aria-hidden="true"></i>
            </span>
            <div class="bq-step-option__text">
              <span class="bq-step-option__title">{{ option.title }}</span>
              <span class="bq-step-option__subtitle">{{ option.subtitle }}</span>
            </div>
          </div>
        </ng-template>
      </app-select-field>
    </app-form-field>

    <app-form-field label="Room"
                    inputId="add-item-room"
                    [required]="true"
                    [control]="form.controls.lotAreaIdentifier"
                    [invalid]="isInvalid('lotAreaIdentifier')"
                    [errorMessages]="{ required: 'Please select a room.' }">
      <app-select-field inputId="add-item-room"
                        [filter]="true"
                        formControlName="lotAreaIdentifier"
                        [options]="areas"
                        optionLabel="name"
                        optionValue="identifier"
                        [autoFocusFilter]="false"
                        placeholder="Select Room"
                        [invalid]="isInvalid('lotAreaIdentifier')"
                        testId="add-new-item-room" />
    </app-form-field>

    <app-form-field label="Notes"
                    inputId="add-item-notes"
                    [required]="true"
                    [control]="form.controls.text"
                    [invalid]="isInvalid('text')"
                    [maxLength]="maxNoteLength"
                    [errorMessages]="{ required: 'Please add a note.' }">
      <app-textarea inputId="add-item-notes"
                    formControlName="text"
                    placeholder="Describe the item..."
                    [showCount]="false"
                    [maxLength]="maxNoteLength"
                    [invalid]="isInvalid('text')"
                    testId="add-new-item-notes" />
    </app-form-field>

    <app-form-field label="Photos"
                    [required]="true"
                    [labelSuffix]="'(Max ' + maxPhotos + ')'"
                    [control]="form.controls.photos"
                    [invalid]="isInvalid('photos')"
                    [errorMessages]="{ required: 'At least one photo is required.' }">
      <app-photo-capture inputId="add-item"
                         [images]="allImages()"
                         [invalid]="isInvalid('photos')"
                         [disabled]="imageCompressionPipelineService.isCompressingImages()"
                         [loading]="imageCompressionPipelineService.isLoadingImages()"
                         [optimizing]="imageCompressionPipelineService.isCompressingImages()"
                         [processingCount]="imageCompressionPipelineService.numberOfImagesBeingProcessed()"
                         (filesSelected)="onPhotosSelected($event)"
                         (imageClicked)="openImagesModal($event)"
                         testId="add-new-item-photo" />
    </app-form-field>

    @if (vendors.length > 0) {
      <app-form-field label="Vendor"
                      inputId="add-item-vendor"
                      [optional]="true">
        <app-select-field inputId="add-item-vendor"
                          [filter]="true"
                          formControlName="externalVendorId"
                          [options]="vendors"
                          optionLabel="name"
                          optionValue="id"
                          [autoFocusFilter]="false"
                          placeholder="Select Vendor"
                          [showClear]="true"
                          testId="add-new-item-vendor-select" />
      </app-form-field>
    }

  </form>

  <app-vertical-button-group [buttons]="footerButtons"
                             testId="add-new-item-footer" />
</app-standard-bottom-sheet>